import { render, staticRenderFns } from "./praise.vue?vue&type=template&id=18c16af2&scoped=true&"
import script from "./praise.vue?vue&type=script&lang=js&"
export * from "./praise.vue?vue&type=script&lang=js&"
import style0 from "./praise.vue?vue&type=style&index=0&id=18c16af2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c16af2",
  null
  
)

export default component.exports